// extracted by mini-css-extract-plugin
export default {"content":"SideBar_content__WVHJh","filterContainer":"SideBar_filterContainer__vQG4x","locationsWrapper":"SideBar_locationsWrapper__UlEJP"};